export default __webpack_public_path__ + "static/media/withholdingTaxNoItems.c69cf9e2.svg";